"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var ThumbsUp = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M9,20 C9,20.5522847 8.55228475,21 8,21 L5,21 C4.44771525,21 4,20.5522847 4,20 L4,11 C4,10.4477153 4.44771525,10 5,10 L8,10 C8.3483915,10 8.65517144,10.1781603 8.83420234,10.4483434 L10.062,9.23 L12.1396204,3 L13,3 C14.1045695,3 15,3.8954305 15,5 L15,9 L19.0173959,9 C20.1219654,9 21.0173959,9.8954305 21.0173959,11 C21.0173959,11.131704 21.0043865,11.2630859 20.9785572,11.3922323 L19.5785572,18.3922323 C19.3915875,19.3270807 18.5707579,20 17.6173959,20 L10.2928932,20 L9,18.707 L9,20 Z M8,11 L5,11 L5,20 L8,20 L8,11 Z M13,4 L12.86,4 L10.937016,9.77009076 L9,11.706 L9,17.293 L10.707,19 L17.6162978,19 C18.0929788,19 18.5033937,18.6635403 18.5968785,18.1961161 L19.9968785,11.1961161 C20.1051904,10.6545564 19.7539737,10.1277313 19.212414,10.0194193 C19.1478408,10.0065047 19.0821498,10 19.0162978,10 L14,10 L14,5 C14,4.44771525 13.5522847,4 13,4 Z" })));
};
ThumbsUp.displayName = 'ThumbsUp';
exports.default = ThumbsUp;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=ThumbsUp.js.map